import { render } from "./confirmActive.vue?vue&type=template&id=0152c1ee&scoped=true"
import script from "./confirmActive.vue?vue&type=script&lang=js"
export * from "./confirmActive.vue?vue&type=script&lang=js"

import "./confirmActive.vue?vue&type=style&index=0&id=0152c1ee&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0152c1ee"]])

export default __exports__